import { Stack, StackProps, styled } from '@mui/material';

import { hexToRgba } from '../../../../../utils/color';

export const Root = styled((props: StackProps) => (
  <Stack direction="row" alignItems="center" gap={1} p={2} {...props} />
))(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.spacing(2),
  boxShadow: `0px 0px 4px 2px ${hexToRgba(theme.palette.warning[400], 0.3)}`,
}));
